export class TimeBasedAccessControl {

    Id: number;
    TimeZoneId: number;
    TimeZoneDisplayName: string;
    WeekDays: Array<number> = [];
    StartTime: string | TimeSpan;
    EndTime: string | TimeSpan;

    constructor(timebasedAccess: TimeBasedAccessControl) {
        this.Id = timebasedAccess.Id || 0;
        this.TimeZoneId = timebasedAccess.TimeZoneId || 0;
        this.TimeZoneDisplayName = timebasedAccess.TimeZoneDisplayName || "";
        this.WeekDays = timebasedAccess.WeekDays || [];
        if (timebasedAccess.StartTime) {
            this.StartTime = new TimeSpan(timebasedAccess.StartTime as TimeSpan);
        }
        else
            this.StartTime = "";

        if (timebasedAccess.EndTime)
            this.EndTime = new TimeSpan(timebasedAccess.EndTime as TimeSpan);
        else
            this.EndTime = "";
    }

    public formatTime(date: Date) {
        return (date.getHours().toString() + ":" + date.getMinutes().toString());
    }

    isValidTime(startDate: Date, endDate: Date): boolean {
        var duration = (endDate.getHours() * 60 + endDate.getMinutes()) - (startDate.getHours() * 60 + startDate.getMinutes());
        if (duration != 0)
            return true;
        else
            return false;
    }

}


export class Day {

    Name: string;
    Id: number;
    Enabled: boolean;

    constructor(day: Day) {
        this.Id = day.Id || 0;
        this.Enabled = day.Enabled || false;
        this.Name = day.Name || "";
    }
}


export class TimeSpan {

    Hours: string;
    Minutes: string;

    constructor(ts: TimeSpan) {
        this.Hours = this.formatNumber(ts.Hours.toString() || "");
        this.Minutes = this.formatNumber(ts.Minutes.toString() || "");
    }

    private formatNumber(value: string) {
        if (value.length == 1) {
            value = "0" + value;
        }
        return value;
    }

} 